<ng-template #fetching>
    <div class="fetching">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<div
    class="store-stock-facet"
    [class.disabled]="disabled"
    *ngIf="storesService.allStores$ | async as stores; else fetching"
>
    <label class="checkbox-wrapper">
        <input
            class="kk-checkbox kk-visuallyhidden"
            type="checkbox"
            [formControl]="checkbox"
            name="store-stock-facet"
            [checked]="(filterService.queryParams$ | async)?.[storeIdParamKey]"
        />
        <span class="kk-checkbox__element checkbox-element">
            <span class="kk-checkbox__icon">
                <app-svg-icon iconName="tick"></app-svg-icon>
            </span>
        </span>
        <span class="text display-label">
            {{ 'stock.buttons.stockStatusFromStore' | translateSafe }}
        </span>
    </label>
    <button
        class="choose-store-button kk-hover-underline"
        [class.disabled]="
            ((storesService.favoriteStore$ | async)?.storeId | canChangeStoreInReservation | async) === false
        "
        (click)="openStockOverlay()"
    >
        <ng-container *ngIf="store$ | async as store; else chooseStoreText">
            {{ (stores | findStoreFromId: store.storeId || '')?.storeName }}
        </ng-container>
        <ng-template #chooseStoreText>
            {{ 'stock.buttons.selectStore' | translateSafe }}
        </ng-template>
        <span class="chevron" aria-hidden="true">
            <app-svg-icon iconName="chevron_down"></app-svg-icon>
        </span>
    </button>
</div>
